import { render, staticRenderFns } from "./DashboardServersHealth.vue?vue&type=template&id=60b1e466"
import script from "./DashboardServersHealth.vue?vue&type=script&lang=js"
export * from "./DashboardServersHealth.vue?vue&type=script&lang=js"
import style0 from "./DashboardServersHealth.vue?vue&type=style&index=0&id=60b1e466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports